import { gql } from '@apollo/client';

export const UPDATE_QUESTIONNAIRE_RESPONSE = gql`
  mutation UpdateQuestionnaireResponse(
    $record: UpdateQuestionnaireResponseInput!
  ) {
    questionnaire {
      updateQuestionnaireResponse(record: $record) {
        ok
        error {
          message
          code
        }
        resultId
        result {
          id
          mainScoreMetric {
            status
            components {
              score
            }
          }
        }
      }
    }
  }
`;
